const prepareRenewMemberTypes = ({ memberTypes }) => {
	return memberTypes?.map(type => ({ id: type.id, name: type.member_type })) ?? [];
};

export default prepareRenewMemberTypes;
